import { NgxLoggerLevel } from 'ngx-logger';

export const ownerEnvironment = {
  beta: false,
  enableMedicalRecordsV2: true,

  apiUrl: 'https://beta.api.petszel.com/',
  logger: {
    level: NgxLoggerLevel.INFO,
    serverLogLevel: NgxLoggerLevel.ERROR,
    disableConsoleLogging: false,
  },
};
